<template>
  <div class="image-meta modal-content">
    <div class="box">
      <header class="title is-5">Please enter Image Metadata</header>
      <form class="image-meta__form" @submit.prevent="updateMetaHandler">
        <b-field label="Add some tags">
          <b-taginput
            v-model="tags"
            ellipsis
            icon="label"
            placeholder="Add a tag"
          ></b-taginput>
        </b-field>
        <div class="field">
          <b-switch v-model="overwrite"
            >Overwrite File if already exists:</b-switch
          >
        </div>
        <b-button class="is-fullwidth" native-type="submit" type="is-primary"
          >Update</b-button
        >
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      tags: [],
      overwrite: false
    };
  },
  methods: {
    async updateMetaHandler() {
      const data = { tags: this.tags, overwrite: this.overwrite };
      this.$emit('input', data);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.image-meta {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
